import onlineInfoStore from "../store/onlineInfo";

// Custom hook để sử dụng và cập nhật cấu hình player
const useOnlineInfo = (playerId) => {
    const onlines = onlineInfoStore((state) => state.onlines);
    const setOnline = onlineInfoStore((state) => state.setOnline);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        online: playerId == null ? false : onlines[playerId] || false, // Nếu không có playerId, trả về object rỗng
        onlines,
        setOnline,
    };
};

export default useOnlineInfo;
